import { apiGateway, api } from "../config";
import { queryParamsToString } from "utils/requestHelpers/requestHelpers";

type GetParams = {
    [key: string]: string | number
}

class SellerService {

    list(params?: GetParams) {
        let query = '';

        if(params) {
            query = queryParamsToString(params)
        }

        return api(`${apiGateway.sellers}?${query}`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache"
            }
        })
    }

    getCurrentSellerStatistic(sellerId: number) {
        return api(`${process.env.REACT_APP_LEGACY_APP_URL}/api/internal/v1/sellers/${sellerId}/statistics`, {
            method: "GET"
        })
    }

    getSellerById(sellerId: number) {
        return api(`${apiGateway.sellers}/${sellerId}`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache"
            }
        })
    }

    getSellersByName(name: string) {
        return api.get(`${apiGateway.sellers}?name=${name}`, {
            method: "GET",
        })
    }

    getConnectedMarkets(sellerId: number) {
        return api(apiGateway.legacyPublicAPIv2 + `/sellers/connected-marketplaces?seller=${sellerId}`, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
            },
        })
    }

    isAiClientAvailable(sellerId: number) {
        return api.get(`${process.env.REACT_APP_LEGACY_APP_URL}/api/internal/v1/ai-client/${sellerId}/is-available`);
    }

    getReviewIFrameUrl(sellerId: number) {
        return api.get(`${process.env.REACT_APP_LEGACY_APP_URL}/api/internal/v1/ai-client/${sellerId}/review`);
    }

    registerAiClient(sellerId: number, core: string[]) {
        const formData = new FormData();
        core.forEach(v => formData.append('core[]', v));
        return api.post(`${process.env.REACT_APP_LEGACY_APP_URL}/api/internal/v1/ai-client/${sellerId}/register`, formData);
    }

}

export default new SellerService();